/**
 * path:路由地址
 * name：路由名称
 * component：模板
 * title：浏览器标题名称
 * loginAuth:是否需要登录
 * visitAuth:是否校验访问权限
 * keepAlive:页面是否缓存
 * showHeader:是否显示头
 * showMenu:是否显示菜单
 */
export const aryRouter = [
    {
        path:'/',
        component: () => import('@/pages/index.vue'),
        meta:{
            title:'首页',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/noauth',
        name:'Noauth',
        component: () => import('@/pages/noauth.vue'),
        meta:{
            title:'无访问权限',
            loginAuth:false,
            visitAuth:false,
            keepAlive:false,
            showHeader:false,
            showMenu:false,
        }
    },
    {
        path:'/loginexpired',
        name:'LoginExpired',
        component: () => import('@/pages/loginexpired.vue'),
        meta:{
            title:'登录超时',
            loginAuth:false,
            visitAuth:false,
            keepAlive:false,
            showHeader:false,
            showMenu:false,
        }
    },
    {
        path:'/401',
        name:'401',
        component: () => import('@/pages/401.vue'),
        meta:{
            title:'401',
            loginAuth:false,
            visitAuth:false,
            keepAlive:false,
            showHeader:false,
            showMenu:false,
        }
    },
    {
        path:'/login',
        name:'loign',
        component: () => import('@/pages/login.vue'),
        meta:{
            title:'用户登录',
            loginAuth:false,
            visitAuth:false,
            keepAlive:false,
            showHeader:false,
            showMenu:false,
        }
    },
    {
        path:'/statistic/analysis/index',
        component: () => import('@/pages/statistic/analysis/index.vue'),
        meta:{
            title:'统计分析',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/statistical/ledger/index',
        component: () => import('@/pages/statistic/ledger/index.vue'),
        meta:{
            title:'统计台账',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/contract',
        component: () => import('@/pages/ammg/contract/index.vue'),
        meta:{
            title:'合同签订',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/template',
        component: () => import('@/pages/ammg/template/index.vue'),
        meta:{
            title:'合同模板',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/pmc',
        component: () => import('@/pages/ammg/pmc/index.vue'),
        meta:{
            title:'物业公司管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/receivepay',
        component: () => import('@/pages/receivepay/receivepay/index.vue'),
        meta:{
            title:'收款管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/receivepay/notice',
        component: () => import('@/pages/receivepay/notice/index.vue'),
        meta:{
            title:'催收预警通知',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/tenants/message',
        component: () => import('@/pages/tenant/message/index.vue'),
        meta:{
            title:'租户留言',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/tenants/repair',
        component: () => import('@/pages/tenant/repair/index.vue'),
        meta:{
            title:'租户报修',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/user',
        component: () => import('@/pages/system/user/index.vue'),
        meta:{
            title:'用户管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/dept',
        component: () => import('@/pages/system/dept/index.vue'),
        meta:{
            title:'部门管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/role',
        component: () => import('@/pages/system/role/index.vue'),
        meta:{
            title:'角色管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/city',
        component: () => import('@/pages/system/city/index.vue'),
        meta:{
            title:'城市管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/project',
        component: () => import('@/pages/property_manage/project/index.vue'),
        meta:{
            title:'资产项目管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/propertytype',
        component: () => import('@/pages/property_manage/type/index.vue'),
        meta:{
            title:'资产类型管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/property',
        component: () => import('@/pages/property_manage/info/index.vue'),
        meta:{
            title:'资产信息台账',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/menu',
        component: () => import('@/pages/system/menu/index.vue'),
        meta:{
            title:'菜单管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/post',
        component: () => import('@/pages/system/post/index.vue'),
        meta:{
            title:'岗位管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/dict',
        component: () => import('@/pages/system/dict/index.vue'),
        meta:{
            title:'字典管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },

    {
        path:'/bulletin',
        component: () => import('@/pages/system/bulletin/index.vue'),
        meta:{
            title:'公告管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/notice',
        component: () => import('@/pages/system/notice/index.vue'),
        meta:{
            title:'通知管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/user/notice',
        component: () => import('@/pages/system/notice/index.vue'),
        meta:{
            title:'通知管理',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/map/children',
        component: () => import('@/pages/map/level_two_map/index.vue'),
        meta:{
            title:'地图',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/statisticalanalysis',
        component: () => import('@/pages/statisticalanalysis/index.vue'),
        meta:{
            title:'统计分析',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/earlywarning',
        component: () => import('@/pages/earlywarning/index.vue'),
        meta:{
            title:'催收预警',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/repair',
        component: () => import('@/pages/repair/index.vue'),
        meta:{
            title:'租户保修',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/leavemessage',
        component: () => import('@/pages/leavemessage/index.vue'),
        meta:{
            title:'租户留言',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/system/statisticalledger',
        component: () => import('@/pages/statisticalledger/index.vue'),
        meta:{
            title:'系统台账',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/system/ccstatisticalledger',
        component: () => import('@/pages/cc_statisticalledger/index.vue'),
        meta:{
            title:'系统台账',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/OutstandingRentList',
        component: () => import('@/pages/outstandingRentList/index.vue'),
        meta:{
            title:'欠缴租金',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/arrearsledger',
        component: () => import('@/pages/arrearsledger/index.vue'),
        meta:{
            title:'租金欠缴提醒',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    /*{
          path:'/info',
          component: () => import('@/pages/xxl/jobInfo/index.vue'),
          meta:{
              title:'系统台账',
              loginAuth:true,
              visitAuth:false,
              keepAlive:false,
              showHeader:true,
              showMenu:true
          }
      },*/

    {
        path:'/operation',
        component: () => import('@/pages/operation/index.vue'),
        meta:{
            title:'资产运营情况',
            loginAuth:true,
            visitAuth:false,
            keepAlive:false,
            showHeader:true,
            showMenu:true
        }
    },
    {
        path:'/pdf',
        component: () => import('@/pages/pdf/index.vue'),
        meta:{
            title:'预览',
            loginAuth:false,
            visitAuth:false,
            keepAlive:false,
            showHeader:false,
            showMenu:false
        }
    },


]
